import { LEGAL_PAGE_SPECIFIC_DATA_LAYER_SESSION_STORAGE_KEYS } from './constants';
export const updatePageSpecificDataLayer = (resolvedUrl: string) => {
  const pageSpecificDataLayerKeys = sessionStorage.getItem(LEGAL_PAGE_SPECIFIC_DATA_LAYER_SESSION_STORAGE_KEYS);

  /* The incoming URL may have a ".mi" suffix (e.g., "/marriott/confirmation.mi") or a locale prefix (e.g., "/fr/marriott/confirmation.mi").
     Due to NGINX and AEM Dispatcher, these suffixes or prefixes are stripped before the request reaches Next.js.
     As a result, the `resolvedUrl` received in this function from preProcessor call is a simplified form (e.g., "/marriott/confirmation"). */

  if (resolvedUrl === '/marriott/confirmation' && pageSpecificDataLayerKeys) {
    Object.assign(window?.dataLayer || {}, JSON.parse(pageSpecificDataLayerKeys));
    return;
  }
  sessionStorage.removeItem(LEGAL_PAGE_SPECIFIC_DATA_LAYER_SESSION_STORAGE_KEYS);
};
